import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Redirects signed-in users away from /chat to ConciergeLayout with the
 * floating widget open. Preserves intent query params (brief, recipient,
 * celebration_id, etc.) and strips nothing the floating concierge needs.
 */
export function AuthedChatGate({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (loading || !session) return;

    const next = new URLSearchParams(searchParams);
    next.set("floating", "open");

    const from = searchParams.get("from");
    const target = from === "orders" ? "/orders" : "/dashboard";

    navigate(`${target}?${next.toString()}`, { replace: true });
  }, [loading, session, navigate, searchParams]);

  if (loading || session) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-navy border-t-transparent" />
      </div>
    );
  }

  return <>{children}</>;
}
